module.exports = __webpack_public_path__ + "static/media/gains.8254de29.png";